import * as React from 'react';
import Spinner from './Spinner';
import {fetchVersion} from "../../actions/versionActions";
import Utils from "../../Utils";
import Modal from "react-responsive-modal";
import './footer.css';

interface Props {
}

interface State {
    pending: boolean;
    feBuildDetails: {
        commit: string;
        version: string;
        timestamp: string
    };

    buildDate: string;
    buildVersion: string;
    projectVersion: string;

    feVersionBehind: boolean;
    showClearCacheModal: boolean;
}

class Footer extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            pending: false,
            feBuildDetails: {
                commit: "n/a",
                version: "n/a",
                timestamp: ""
            },
            buildDate: "",
            buildVersion: "",
            projectVersion: "",
            feVersionBehind: false,
            showClearCacheModal: false
        }
    }

    UNSAFE_componentWillMount(): void {
        this.setState({pending: true}, () => {
            fetchVersion()
                .then(response => {
                    this.setState({
                        pending: false,
                        buildDate: response.data.buildDate,
                        buildVersion: response.data.buildVersion,
                        projectVersion: response.data.projectVersion
                    })
                })
                .catch(error => {
                    this.setState({pending: false});
                });
        });

        // prevent version.txt caching
        const currentTs = Math.floor(Date.now()/1000);
        Utils.axios.get(`${process.env.ENV_PREFIX}/version.txt?${currentTs}`)
            .then(response => {
                const buildTs = response.data["timestamp"];
                const localStorageBuildTs = localStorage.getItem(Utils.LOCAL_STORAGE_ITEM_BUILD_FE_TS);
                if (!localStorageBuildTs) {
                    localStorage.setItem(Utils.LOCAL_STORAGE_ITEM_BUILD_FE_TS, buildTs);
                } else if (buildTs !== localStorageBuildTs) {
                    this.setState({
                        showClearCacheModal: true,
                        feVersionBehind: true
                    });
                }
                this.setState({
                    feBuildDetails: {
                        commit: response.data["commit"],
                        version: response.data["version"],
                        timestamp: buildTs
                    }
                })
            })
            .catch(error => {
                console.error(error);
            })
    }

    applyActionCacheModal = (isModalOpen: boolean) => {
        this.setState({
            showClearCacheModal: isModalOpen
        })
    };

    clearCacheAndReload = () => {
        if('caches' in window){
            caches.keys().then((names) => {
                // Delete all the cache files
                names.forEach(name => {
                    caches.delete(name);
                })
            });
            // Reload the Page to view changes.
            localStorage.removeItem(Utils.LOCAL_STORAGE_ITEM_BUILD_FE_TS);
            window.location.reload();
        }
    }

    render() {
        let footerStyle = {
            minWidth: 800,
            width: '100%'
        };
        return (
            <div className="footer-container">
                <div style={footerStyle} className="footer">
                    <div className="pull-right">
                        <strong>Panaton &copy;</strong>
                    </div>
                    {this.state.pending ?
                        <Spinner/> :
                        (<div>
                            <span className="m-l-xs"><strong>Version: </strong> {this.state.projectVersion}</span>
                            <span
                                className="m-l-xs"><strong>Build: </strong> {this.state.buildVersion} {this.state.feBuildDetails.version}</span>
                            <span
                                className="m-l-xs"><strong>Date: </strong>BE {Utils.moment(this.state.buildDate, Utils.moment.ISO_8601).isValid() ? Utils.formatDate(Utils.moment.utc(this.state.buildDate).utcOffset(Utils.moment(this.state.buildDate).format("ZZ").toString())) : "n/a"} FE {Utils.moment(this.state.feBuildDetails.timestamp, Utils.moment.ISO_8601).isValid() ? Utils.formatDate(Utils.moment.utc(this.state.feBuildDetails.timestamp).utcOffset(Utils.moment(this.state.feBuildDetails.timestamp).format("ZZ").toString())) : "n/a"}</span>
                        </div>)
                    }
                    <Modal
                        open={this.state.showClearCacheModal}
                        styles={{
                            overlay: {zIndex: 10000},
                            closeButton: {display: "none"},
                            modal: {
                                width: 750,
                                padding: 0,
                                maxWidth: 750
                            }
                        }}
                        closeOnEsc={true}
                        onClose={() => this.applyActionCacheModal(false)}
                        center
                        focusTrapped={true}
                        closeOnOverlayClick={false}
                    >
                        <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                            <div className="row" style={{height: '100%'}}>
                                <div id={'create-user-container'} className='col-lg-12 compare-changes' style={{color: '#f5f5f5a3'}}>
                                    <header className={'create-functionality-modal-header'} style={{paddingBottom: '6px'}}>
                                        <h2>Old version detected</h2>
                                    </header>
                                    <div className="modal-content-container">
                                        <h3>Please, clear your browser cache and reload the page.</h3>
                                    </div>
                                    <footer style={{
                                        background: "#2D3436",
                                        borderTop: "2px solid #f5f5f5a3",
                                        height: 49,
                                        width: "100%",
                                        paddingRight: 5,
                                        paddingTop: 3,
                                    }}>
                                        <button
                                            onClick={() => this.applyActionCacheModal(false)}
                                            className={"btn"}
                                            style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                            <i className="fas fa-times"> Close</i>
                                        </button>
                                        <button
                                            onClick={this.clearCacheAndReload}
                                            className={"btn"}
                                            style={{float: "right", marginTop: 3, marginRight: 5}}>
                                            <i className="fas fa-redo-alt"> Clear Cache & Reload</i>
                                        </button>
                                    </footer>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                {this.state.feVersionBehind ?
                    <div className="new-version-container">
                        <button
                            className={"btn footer-new-version-button button-pulse"}
                            onClick={() => this.applyActionCacheModal(true)}>
                            <i className="fas fa-angle-double-up"> New UI Version Available</i>
                        </button>
                    </div>
                    : null
                }
            </div>
        )
    }
}

export default Footer



// WEBPACK FOOTER //
// ./app/components/common/Footer.tsx